var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedeliver6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C11.7156 0 11.9313 0.046875 12.1281 0.135938L20.9547 3.88125C21.986 4.31719 22.7547 5.33438 22.75 6.5625C22.7266 11.2125 20.8141 19.7203 12.7375 23.5875C11.9547 23.9625 11.0453 23.9625 10.2625 23.5875C2.18596 19.7203 0.273459 11.2125 0.250021 6.5625C0.245334 5.33438 1.01408 4.31719 2.04533 3.88125L10.8766 0.135938C11.0688 0.046875 11.2844 0 11.5 0ZM11.5 3.13125V20.85C17.9688 17.7188 19.7078 10.7859 19.75 6.62813L11.5 3.13125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedeliver6);
export default __webpack_public_path__ + "static/media/wedeliver6.e00d1474978a34c840e9e6666cd065c1.svg";
export { ForwardRef as ReactComponent };